module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "160px",
      "height": "454px",
      "viewBox": "0 0 160 454",
      "id": "joe"
    }
  }, [_c('g', {
    attrs: {
      "id": "joe_outer"
    }
  }, [_c('g', {
    attrs: {
      "id": "joe_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "joe_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.8598555,245.237344 C35.7352775,248.068615 33.7256947,249.583229 31.7153239,252.862806 C29.3697183,256.689262 29.3716627,263.683795 26.7136308,269.511047 C27.3689864,270.891215 31.6699935,268.469811 32.613426,266.124408 C33.5568585,263.779004 34.2769315,261.871609 34.5961563,261.280905 C34.9153811,260.690201 35.653847,260.755782 35.8592877,261.330205 C36.0647284,261.904627 35.8831236,282.539395 36.3106952,283.564935 C36.7382668,284.590475 39.3093958,284.71102 39.7914345,283.679455 C40.2734731,282.647891 40.8164848,266.334608 41.0497618,265.905182 C41.2830387,265.475757 41.8407202,265.704485 42.0710588,265.938784 C42.3013974,266.173084 41.2452904,283.583825 41.60541,284.244873 C41.9655295,284.905922 44.6263823,284.880967 44.9335699,284.354374 C45.2407576,283.827781 45.9817029,266.462233 46.2851631,266.077434 C46.5886234,265.692634 47.1723196,265.756047 47.3988407,266.114075 C47.6253618,266.472103 46.3533601,283.175967 46.7407975,283.908098 C47.1282348,284.640229 49.7036799,284.736317 49.9676796,284.014266 C50.2316793,283.292215 51.3795843,266.489657 51.6381225,266.253553 C51.8966606,266.017448 52.2314522,266.051341 52.4610285,266.280627 C52.6906049,266.509913 52.4776119,279.080769 52.8633419,279.777064 C53.249072,280.473359 55.1925621,280.698828 55.511142,279.86418 C55.8297219,279.029532 55.5881334,248.360301 55.6892444,246.662056 C56.0262034,241.002539 52.8731759,234.975832 46.1082548,234.753258 C39.3433337,234.530683 36.1273764,239.157427 35.8598555,245.237344 Z",
      "id": "boy2_right_hand",
      "fill": "#C98A44",
      "transform": "translate(41.213631, 259.745554) rotate(4.000000) translate(-41.213631, -259.745554) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.8068321,176.167858 L48.8068321,176.167858 L48.8068321,176.167858 C54.3296796,176.167858 58.8068321,180.645011 58.8068321,186.167858 L58.8068321,245.167858 L58.8068321,245.167858 C58.8068321,250.690706 54.3296796,255.167858 48.8068321,255.167858 L48.8068321,255.167858 L48.8068321,255.167858 C43.2839846,255.167858 38.8068321,250.690706 38.8068321,245.167858 L38.8068321,186.167858 L38.8068321,186.167858 C38.8068321,180.645011 43.2839846,176.167858 48.8068321,176.167858 Z",
      "id": "boy2_right_arm_bottom",
      "fill": "#C98A44",
      "transform": "translate(48.806832, 215.667858) rotate(4.000000) translate(-48.806832, -215.667858) "
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_right_arm_top",
      "fill": "#C98A44",
      "transform": "translate(53.096855, 154.317669) rotate(4.000000) translate(-53.096855, -154.317669) ",
      "x": "43.0968552",
      "y": "112.317669",
      "width": "20",
      "height": "84",
      "rx": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.4919847,112.366388 L54.4919847,112.366388 L54.4919847,112.366388 C60.1215786,112.366388 64.7892767,116.726671 65.1722236,122.343225 L67.4919847,156.366388 L41.4919847,156.366388 L43.8117458,122.343225 L43.8117458,122.343225 C44.1946927,116.726671 48.8623908,112.366388 54.4919847,112.366388 Z",
      "id": "boy2_right_sleeve",
      "fill": "#DD8C32",
      "transform": "translate(54.491985, 134.366388) rotate(4.000000) translate(-54.491985, -134.366388) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.4922465,426 C45.3528811,427.950464 33.60521,432.438015 30.7853856,433.601772 C27.9655613,434.765529 24.4123653,439.995 26.7690749,444 C29.1260524,444 71.2521558,444 74.8016662,444 C76.3994446,443.775114 76.3994446,437.775114 74.8016662,426 C60.7737829,426 52.3373097,426 49.4922465,426 Z",
      "id": "boy2_right_shoe",
      "fill": "#B97B36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62,302 L62,302 L62,302 C70.2842712,302 77,308.715729 77,317 L77,426 L47,426 L47,317 L47,317 C47,308.715729 53.7157288,302 62,302 Z",
      "id": "boy2_right_leg_bottom",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_right_leg_top",
      "fill": "#955208",
      "x": "47",
      "y": "204",
      "width": "30",
      "height": "128",
      "rx": "15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.4922465,426 C85.3528811,427.950464 73.60521,432.438015 70.7853856,433.601772 C67.9655613,434.765529 64.4123653,439.995 66.7690749,444 C69.1260524,444 111.252156,444 114.801666,444 C116.399445,443.775114 116.399445,437.775114 114.801666,426 C100.773783,426 92.3373097,426 89.4922465,426 Z",
      "id": "boy2_left_shoe",
      "fill": "#B97B36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102,302 L102,302 L102,302 C110.284271,302 117,308.715729 117,317 L117,426 L87,426 L87,317 L87,317 C87,308.715729 93.7157288,302 102,302 Z",
      "id": "boy2_left_leg_bottom",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M102,204 L102,204 L102,204 C110.284271,204 117,210.715729 117,219 L117,317 L117,317 C117,325.284271 110.284271,332 102,332 L102,332 L102,332 C93.7157288,332 87,325.284271 87,317 L87,219 L87,219 C87,210.715729 93.7157288,204 102,204 Z",
      "id": "boy2_left_leg_top",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,210 L117,210 L117,220 L117,220 C117,236.568542 103.568542,250 87,250 L77,250 L77,250 C60.4314575,250 47,236.568542 47,220 L47,210 Z",
      "id": "boy2_hip",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67,210 C68.3919088,210 71.7252421,210 77,210 C77,227.819072 77,237.819072 77,240 C67.611781,233.529427 67,226.726359 67,210 Z",
      "id": "boy2_zipper",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M56.0371094,113.796585 C63.5478516,100.265355 99.7089844,101.212164 108.242188,113.796585 C113.93099,122.1862 117.85026,154.254005 120,210 L44,210 C47.0175781,154.88521 51.0299479,122.817405 56.0371094,113.796585 Z",
      "id": "boy2_torso",
      "fill": "#E9973B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.146225,245.49179 C100.021647,248.32306 98.0120639,249.837675 96.0016931,253.117252 C93.6560875,256.943708 93.658032,263.93824 91,269.765492 C91.6553556,271.145661 95.9563627,268.724257 96.8997952,266.378853 C97.8432277,264.03345 98.5633007,262.126055 98.8825255,261.535351 C99.2017503,260.944647 99.9402162,261.010228 100.145657,261.58465 C100.351098,262.159072 100.169493,282.79384 100.597064,283.81938 C101.024636,284.84492 103.595765,284.965465 104.077804,283.933901 C104.559842,282.902336 105.102854,266.589053 105.336131,266.159628 C105.569408,265.730203 106.127089,265.95893 106.357428,266.19323 C106.587767,266.42753 105.53166,283.838271 105.891779,284.499319 C106.251899,285.160367 108.912751,285.135412 109.219939,284.60882 C109.527127,284.082227 110.268072,266.716679 110.571532,266.331879 C110.874993,265.94708 111.458689,266.010493 111.68521,266.368521 C111.911731,266.726548 110.639729,283.430412 111.027167,284.162543 C111.414604,284.894674 113.990049,284.990763 114.254049,284.268712 C114.518048,283.546661 115.665954,266.744103 115.924492,266.507998 C116.18303,266.271893 116.517821,266.305787 116.747398,266.535073 C116.976974,266.764359 116.763981,279.335215 117.149711,280.03151 C117.535441,280.727805 119.478931,280.953274 119.797511,280.118626 C120.116091,279.283978 119.874503,248.614747 119.975614,246.916501 C120.312573,241.256984 117.159545,235.230278 110.394624,235.007703 C103.629703,234.785129 100.413746,239.411872 100.146225,245.49179 Z",
      "id": "boy2_left_hand",
      "fill": "#C98A44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110,176 L110,176 L110,176 C115.522847,176 120,180.477153 120,186 L120,245 L120,245 C120,250.522847 115.522847,255 110,255 L110,255 L110,255 C104.477153,255 100,250.522847 100,245 L100,186 L100,186 C100,180.477153 104.477153,176 110,176 Z",
      "id": "boy2_left_arm_bottom",
      "fill": "#C98A44"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_left_arm_top",
      "fill": "#C98A44",
      "x": "100",
      "y": "112",
      "width": "20",
      "height": "84",
      "rx": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M110,112 L110,112 L110,112 C115.629594,112 120.297292,116.360283 120.680239,121.976837 L123,156 L97,156 L99.3197611,121.976837 L99.3197611,121.976837 C99.702708,116.360283 104.370406,112 110,112 Z",
      "id": "boy2_left_sleeve",
      "fill": "#DD8C32"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.1940049,98.0216188 C72.0079388,103.103763 72.3262895,105.131362 70,107.926773 C70.5957995,108.999195 73.9591157,115 79.925557,115 C85.8919984,115 89.8085332,110.355461 91,107.926773 C88.8933131,105.063071 89.0105895,103.700051 90.2613324,98.0216188 C88.7070947,93.9244956 73.3642938,94.0616757 71.1940049,98.0216188 Z",
      "id": "boy2_neck",
      "fill": "#C98A44"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.11936,62.2924511 C118.220148,61.0463729 121.236043,59.4634048 124.655435,62.2924511 C127.580235,64.7122949 125.381674,74.2056032 121.436234,79.4629674 C117.528187,84.6705049 111.171013,85.7516903 108.675737,83.7555965 C103.411305,95.7232912 89.9945058,102.078394 81.0279927,101.99927 C57.0227509,101.787437 47,77.2820133 47,56.9266647 C47,24.8197747 59.7239908,14.0007996 81.0279927,14.0007996 C100.149633,13.8958751 121.373927,24.0874235 116.11936,62.2924511 Z",
      "id": "boy2_face",
      "fill": "#C98A44",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.4009258,95 C71.8203739,95 84.1437641,95 85.7295607,95 C87.3153572,95 81.626153,92 76.5149987,92 C71.4038444,92 68.9814777,95 70.4009258,95 Z",
      "id": "boy2_mouth_bottom",
      "fill": "#B97B36",
      "transform": "translate(78.000000, 93.500000) scale(1, -1) translate(-78.000000, -93.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.5011572,91 C70.2754673,91 85.6797052,91 87.6619508,91 C89.6441965,91 82.5326913,87 76.1437484,87 C69.7548055,87 66.7268471,91 68.5011572,91 Z",
      "id": "boy2_mouth_top",
      "fill": "#B97B36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.201423,62.3792908 C74.4882945,60.6000736 79.0941953,60.4813569 79.2443505,62.3792908 C79.3945058,64.2772246 80.8653004,75.7491696 79.2468275,77.7428643 C77.6283547,79.7365589 72.8706539,79.0685775 72.1343652,77.7428643 C71.3980764,76.4171511 73.9145515,64.1585079 74.201423,62.3792908 Z",
      "id": "boy2_nose",
      "fill": "#B97B36"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M70.0872659,64.2884047 C67.272062,57.7276872 54.7518133,56.726412 52.8702819,62.4076988 C52.8613497,70.0792479 68.0407525,70.756829 70.0872659,64.2884047 Z",
      "id": "boy2_right_eye_whites",
      "fill": "#FBD79E"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy2_right_pupil",
      "fill": "#955208",
      "cx": "59.630893",
      "cy": "64.1502898",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.304246,64.2884047 C90.1194499,57.7276872 102.639699,56.726412 104.52123,62.4076988 C104.530162,70.0792479 89.3507595,70.756829 87.304246,64.2884047 Z",
      "id": "boy2_left_eye_whites",
      "fill": "#FBD79E"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy2_left_pupil",
      "fill": "#955208",
      "cx": "94.064861",
      "cy": "64.1502898",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.9651236,54.0973966 C69.4247445,51.3810949 52.3650421,51.3383442 52.0226901,53.7648379 C51.6803381,56.1913316 55.2532176,55.034359 59.9555231,55.4986219 C64.6578285,55.9628848 70.5055028,56.8136984 69.9651236,54.0973966 Z",
      "id": "boy2_right_brow",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.0348764,54.0973966 C87.5752555,51.3810949 104.634958,51.3383442 104.97731,53.7648379 C105.319662,56.1913316 101.746782,55.034359 97.0444769,55.4986219 C92.3421715,55.9628848 86.4944972,56.8136984 87.0348764,54.0973966 Z",
      "id": "boy2_left_brow",
      "fill": "#955208"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.3627137,30.2618189 C71.1799907,36.197591 75.6768158,46.5846276 82.853189,61.4229289 L85.056129,61.6817906 L85.056129,61.6817906 C85.8938707,61.7802314 86.6527966,61.1809096 86.7512374,60.3431679 C86.7729706,60.1582156 86.760696,59.970848 86.7150192,59.7903119 L81.4709768,39.0633907 L90.7408578,59.0498288 L90.7408578,59.0498288 C91.2323517,60.1095202 92.2942572,60.7875633 93.4623805,60.7875633 L94.2234905,60.7875633 L94.2234905,60.7875633 C95.2775399,60.7875633 96.1320157,59.9330874 96.1320157,58.8790381 C96.1320157,58.6673628 96.0968019,58.4571622 96.0278163,58.2570437 L88.7259133,37.0751593 L98.8088845,57.8901479 L98.8088845,57.8901479 C99.2820372,58.8669104 100.271873,59.4872797 101.357201,59.4872797 L101.357201,59.4872797 L101.357201,59.4872797 C102.163281,59.4872797 102.816737,58.8338233 102.816737,58.0277439 C102.816737,57.933988 102.807703,57.8404503 102.789761,57.7484273 C101.144861,49.312027 100.346346,44.0556784 100.394223,41.9793802 C102.135041,44.9410556 104.32141,52.8181216 106.953332,65.6105782 L106.953323,65.61058 C107.179987,66.7122798 108.149825,67.5028965 109.2746,67.5028965 L109.2746,67.5028965 L109.2746,67.5028965 C110.212071,67.5028965 110.972041,66.7429263 110.972041,65.8054555 C110.972041,65.7323745 110.967322,65.6593699 110.957912,65.5868972 C109.872821,57.2299137 109.349215,51.4165632 109.38706,48.1468503 C111.121368,52.0333525 113.12233,59.7641456 115.389946,71.3392295 L115.389952,71.3392284 C115.578958,72.304015 116.42452,73 117.407646,73 L117.407646,73 L117.407646,73 C118.365163,73 119.161974,72.2642757 119.238187,71.3097966 L119.779705,64.5279258 L123.978169,71.5409614 L123.978169,71.5409614 C124.519991,72.4460101 125.497324,73 126.552162,73 L127.022943,73 L127.022943,73 C127.9506,73 128.702614,72.2479856 128.702614,71.3203288 C128.702614,71.177952 128.684512,71.0361529 128.648742,70.8983426 L122.961485,48.9868746 L130.198334,62.2322746 L130.198334,62.2322746 C130.879213,63.4784672 132.441412,63.9367448 133.687605,63.2558663 C133.700565,63.2487852 133.713465,63.2415925 133.726301,63.234289 L133.726301,63.234289 L133.726301,63.234289 C135.003852,62.5074176 135.495026,60.9118011 134.8474,59.5923087 L123.795671,37.0751593 L131.386573,42.5111698 L131.386573,42.5111698 C132.426308,43.2557473 133.87278,43.0164743 134.617358,41.9767386 C134.640675,41.9441786 134.663143,41.9110192 134.68474,41.8772939 L134.68474,41.8772939 L134.68474,41.8772939 C135.434432,40.7065919 135.187834,39.1598983 134.111261,38.2803684 L119.02252,25.9532915 L128.899559,28.7108067 L128.899559,28.7108067 C130.348156,29.1152324 131.867223,28.3544803 132.411041,26.9522479 L132.411041,26.9522479 L132.411041,26.9522479 C132.925475,25.6257837 132.267194,24.1334411 130.94073,23.6190074 C130.917877,23.6101448 130.8949,23.6016088 130.871804,23.593402 L94.0550667,10.5110391 L107.366771,5.96071655 L107.366771,5.96071655 C108.575092,5.54767775 109.38706,4.41202717 109.38706,3.13506178 L109.38706,3.13506178 L109.38706,3.13506178 C109.38706,2.01952903 108.482742,1.11521105 107.367209,1.11521105 C107.321813,1.11521105 107.276429,1.11674152 107.231135,1.11979983 C92.6047281,2.10744352 79.434622,6.58440983 67.7208194,14.5507393 C55.1381734,16.9873441 44.3315924,25.0580557 35.3010762,38.7628739 L35.301074,38.7628725 C34.541255,39.9159828 34.7483839,41.4528479 35.7863654,42.3636621 L35.7863654,42.3636621 L35.7863654,42.3636621 C36.7207337,43.1835572 38.1428451,43.0907584 38.9627402,42.1563901 C38.9896367,42.1257384 39.0156952,42.0943613 39.0408868,42.0622938 L46.2869676,32.8384456 L34.9660304,57.3920856 L34.9660304,57.3920856 C34.5053899,58.3911548 34.9418726,59.5744833 35.9409419,60.0351237 C36.0292355,60.0758332 36.1203911,60.1100239 36.2136777,60.1374215 L36.2136777,60.1374215 L36.2136777,60.1374215 C37.4866083,60.5112724 38.841696,59.8989332 39.4023429,58.6965223 L46.2869676,43.9311728 L42.727664,61.9032423 L42.727664,61.9032423 C42.5191663,62.9560144 43.203586,63.9784756 44.2563581,64.1869733 C44.2751501,64.190695 44.2939961,64.1941386 44.3128899,64.197303 L44.3128899,64.197303 L44.3128899,64.197303 C45.4517358,64.3880394 46.5613668,63.7267483 46.9355125,62.6343357 L55.6893992,37.0751593 L53.3726855,57.9994143 L53.3726855,57.9994143 C53.2508509,59.0998084 54.0441302,60.0906206 55.1445243,60.2124552 C55.2177783,60.2205658 55.2914238,60.2246303 55.3651254,60.2246303 L55.3651254,60.2246303 L55.3651254,60.2246303 C56.6683785,60.2246303 57.7919336,59.3081525 58.0538134,58.031482 L62.8258533,34.7676728 L62.2661812,58.5431317 L62.2661812,58.5431317 C62.2360431,59.8234323 63.1680416,60.924029 64.4358106,61.1052461 L64.4358106,61.1052461 L64.4358106,61.1052461 C65.594062,61.2708086 66.6672253,60.4660752 66.8327878,59.3078237 C66.838575,59.2673373 66.8431886,59.2266917 66.8466228,59.1859381 C68.1643859,43.5479028 69.0030882,33.9065302 69.3627137,30.2618189 Z",
      "id": "boy2_hair",
      "fill": "#955208"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3029e408","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/joe.vue
// module id = 1027
// module chunks = 1